import Program from 'wwg-utilities/dist/collections/program';
import ArrowLeft from '../../icons/ArrowLeft';
import GetStartedButton from '../GetStartedButton';
import SaveButton from '../SaveButton';
import useMyRouter from '../../../lib/hooks/myRouter';

interface BottomBarProps {
  program: Program;
  region: string;
}

const BottomBar: React.FC<BottomBarProps> = ({ program, region }) => {
  const { goBack } = useMyRouter()

  return (
    <section className="fixed bottom-0 font-base left-0 right-0 h-[88px] bg-off-gray flex items-stretch z-30">
      <div className="container flex items-stretch justify-between px-2 mx-auto">
        <button
          className="flex items-center flex-1 cursor-pointer"
          onClick={goBack}
        >
          <ArrowLeft className="w-5 h-5" />
          &nbsp;&nbsp; Back to explore
        </button>
        <div className="flex items-stretch flex-1 py-4">
          <SaveButton program={program} small={true} region={region} />
          &nbsp;&nbsp;
          <GetStartedButton location="bottom" program={program} small={true} />
        </div>
      </div>
    </section>
  );
};

export default BottomBar;
